const industryContent = {
  Education: {
    heading: "Education",
    intro:
      "Empowering learning institutions with digital transformation for seamless administration, student engagement, and modern teaching methodologies.",
    sections: [
      {
        title: "Learning Management Systems (LMS)",
        items: [
          "Interactive e-learning platforms",
          "Video classes, quizzes & assignments",
          "Real-time progress tracking",
          "Mobile app for students & parents",
        ],
      },
      {
        title: "School ERP Solutions",
        items: [
          "Attendance automation",
          "Fee management & online payments",
          "Timetable & exam scheduling",
          "Parent-teacher communication portal",
        ],
      },
      {
        title: "Key Benefits",
        text: "Reduce administrative workload by 70%, improve parent engagement, and enable data-driven academic decisions.",
      },
    ],
  },
  "Health Care": {
    heading: "Health Care",
    intro:
      "Digital healthcare solutions to streamline patient care, improve diagnostics, and ensure compliance with medical standards.",
    sections: [
      {
        title: "Hospital Management System",
        items: [
          "OPD/IPD management",
          "Electronic Health Records (EHR)",
          "Appointment scheduling",
          "Pharmacy & lab integration",
        ],
      },
      {
        title: "Telemedicine & Patient Apps",
        items: [
          "Video consultations",
          "Prescription & report access",
          "Health reminders & alerts",
          "Wearable device integration",
        ],
      },
      {
        title: "Compliance",
        text: "HIPAA, NABH, and GDPR compliant systems with secure data encryption.",
      },
    ],
  },
  Accounting: {
    heading: "Accounting",
    intro:
      "Automate financial workflows with intelligent accounting software tailored for accuracy, compliance, and real-time reporting.",
    sections: [
      {
        title: "Core Features",
        items: [
          "Multi-currency bookkeeping",
          "GST & TDS compliance",
          "Automated invoicing & reconciliation",
          "Audit trail & financial dashboards",
        ],
      },
      {
        title: "Integration",
        text: "Seamless integration with Tally, QuickBooks, banking APIs, and payment gateways.",
      },
    ],
  },
  Finance: {
    heading: "Finance",
    intro:
      "Robust fintech solutions for banking, lending, investments, and wealth management with security and scalability at core.",
    sections: [
      {
        title: "Digital Banking Platforms",
        items: [
          "Core banking system",
          "Loan origination & management",
          "KYC & fraud detection",
          "Mobile banking apps",
        ],
      },
      {
        title: "WealthTech",
        text: "Portfolio tracking, mutual fund automation, robo-advisory, and personalized investment plans.",
      },
    ],
  },
  "Shopping / Retail": {
    heading: "Shopping / Retail",
    intro:
      "Omnichannel retail solutions to enhance in-store and online shopping experiences with inventory and customer insights.",
    sections: [
      {
        title: "POS & Inventory",
        items: [
          "Cloud-based POS",
          "Real-time stock updates",
          "Barcode & RFID support",
          "Multi-store management",
        ],
      },
      {
        title: "Customer Loyalty",
        text: "Reward programs, personalized offers, and analytics-driven marketing.",
      },
    ],
  },
  Ecommerce: {
    heading: "Ecommerce",
    intro:
      "Scalable, secure, and conversion-optimized ecommerce platforms with payment, logistics, and marketing integrations.",
    sections: [
      {
        title: "Platform Features",
        items: [
          "Multi-vendor marketplace",
          "AI product recommendations",
          "Abandoned cart recovery",
          "One-click checkout",
        ],
      },
      {
        title: "Growth Tools",
        text: "SEO, email marketing, social commerce, and analytics for 10x growth.",
      },
    ],
  },
  "Social Media": {
    heading: "Social Media",
    intro:
      "Enterprise-grade social media management tools for content scheduling, analytics, and community engagement.",
    sections: [
      {
        title: "All-in-One Dashboard",
        items: [
          "Post scheduling across 10+ platforms",
          "Engagement tracking & responses",
          "Hashtag & trend analysis",
          "Team collaboration",
        ],
      },
      {
        title: "Influencer Marketing",
        text: "Find, manage, and track influencer campaigns with ROI analytics.",
      },
    ],
  },
  GIS: {
    heading: "GIS",
    intro:
      "Geospatial intelligence platforms for urban planning, disaster management, agriculture, and logistics.",
    sections: [
      {
        title: "Mapping & Analytics",
        items: [
          "Real-time satellite imagery",
          "Route optimization",
          "Land use classification",
          "3D terrain modeling",
        ],
      },
      {
        title: "Use Cases",
        text: "Smart cities, precision farming, flood prediction, and asset tracking.",
      },
    ],
  },
  "Human Resources": {
    heading: "Human Resources",
    intro:
      "End-to-end HRMS with payroll, recruitment, performance, and employee wellness modules.",
    sections: [
      {
        title: "HR Automation",
        items: [
          "Employee onboarding & offboarding",
          "Payroll & compliance",
          "Performance appraisals",
          "Leave & attendance tracking",
        ],
      },
      {
        title: "Employee Experience",
        text: "Self-service portal, feedback tools, and career development plans.",
      },
    ],
  },
  Ticketing: {
    heading: "Ticketing",
    intro:
      "Event, transport, and support ticketing systems with QR codes, seat selection, and real-time updates.",
    sections: [
      {
        title: "Event & Transport",
        items: [
          "Online seat booking",
          "QR code entry",
          "Dynamic pricing",
          "Refund & rescheduling",
        ],
      },
      {
        title: "Customer Support",
        text: "Helpdesk ticketing with SLA tracking and omnichannel support.",
      },
    ],
  },
  Construction: {
    heading: "Construction",
    intro:
      "Project management tools for contractors with cost tracking, Gantt charts, and regulatory compliance.",
    sections: [
      {
        title: "Project Lifecycle",
        items: [
          "BOQ & cost estimation",
          "Material & labor tracking",
          "Daily progress reports",
          "Safety compliance",
        ],
      },
      {
        title: "Collaboration",
        text: "Real-time updates for architects, engineers, and clients.",
      },
    ],
  },
  "Food & Beverages": {
    heading: "Food & Beverages",
    intro:
      "Restaurant management systems with online ordering, table reservations, and kitchen display systems.",
    sections: [
      {
        title: "Operations",
        items: [
          "Digital menu & QR ordering",
          "KDS integration",
          "Inventory & recipe management",
          "Table & delivery tracking",
        ],
      },
      {
        title: "Customer Engagement",
        text: "Loyalty programs, feedback, and personalized promotions.",
      },
    ],
  },
  FMCG: {
    heading: "FMCG",
    intro:
      "Supply chain and distribution management for fast-moving goods with demand forecasting and retailer apps.",
    sections: [
      {
        title: "Distribution Network",
        items: [
          "Distributor management",
          "Order fulfillment automation",
          "Scheme & discount engine",
          "Van sales app",
        ],
      },
      {
        title: "Analytics",
        text: "Sales trends, stock ageing, and market share insights.",
      },
    ],
  },
  Manufacturing: {
    heading: "Manufacturing",
    intro:
      "Industry 4.0 solutions with IoT, predictive maintenance, and production planning for smart factories.",
    sections: [
      {
        title: "Smart Manufacturing",
        items: [
          "MES & SCADA integration",
          "IoT sensor monitoring",
          "Predictive maintenance",
          "Quality control automation",
        ],
      },
      {
        title: "ERP",
        text: "End-to-end production planning, procurement, and inventory control.",
      },
    ],
  },
};

export default industryContent;
